import { TFunction } from 'i18next';
import { filterUndefinedRows } from 'src/js/pages/statistic/statistic-mapper';
import { StatisticSectionViewModel } from 'src/js/pages/statistic/statistic-view-model';
import { toTitleCase } from 'src/js/util/global-util';
import { formatUptime } from '../stream/stream-helper';

import { St2110ViewModel, st2110StateToName } from './st2110-models';
import { isEmpty } from 'lodash';

export const mapSt2110ToStatistics = (st2110: St2110ViewModel, t: TFunction): StatisticSectionViewModel[] => {
  const stats = [
    {
      title: t('st2110.statistics.st2110'),
      rows: [
        {
          name: t('general.name'),
          value: !isEmpty(st2110.name) ? st2110.name : t('stream.unnamedStream'),
        },
        {
          name: t('general.status'),
          value: toTitleCase(st2110StateToName(st2110.state, t), false),
        },
        {
          name: t('st2110.statistics.mediaType'),
          value: toTitleCase(st2110.type),
        },
        {
          name: t('st2110.statistics.streamSync'),
          value: st2110.stats.streamSync ? t('general.on') : t('general.off'),
        },
        {
          name: t('st2110.statistics.txPackets'),
          value: st2110.stats.txPackets,
        },
        {
          name: t('st2110.statistics.videoFormatDetectionState'),
          value: toTitleCase(st2110.stats.videoFormatDetectionState, false),
        },
        {
          name: t('st2110.statistics.detectedVideoFormat'),
          value: st2110.stats.detectedVideoFormat,
        },
        {
          name: t('st2110.lastReset'),
          value: formatUptime(st2110.stats.lastReset),
        },
      ],
    },
  ];

  return filterUndefinedRows(stats);
};
